import React from 'react';
import styled from 'styled-components';
import { STATUS_BADGE_STYLES } from '../../constants';

interface StatusBadgeProps {
  status: string;
  children?: React.ReactNode;
}

const Badge = styled.span<{ $bg: string; $color: string }>`
  display: inline-block;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  background: ${props => props.$bg};
  color: ${props => props.$color};
`;

const DEFAULT_STYLE = { bg: '#f3f4f6', color: '#4b5563' };

/**
 * 상태 표시 배지 컴포넌트
 * 대기/승인/반려 등 상태에 따라 색상이 변경됨
 */
export default function StatusBadge({ status, children }: StatusBadgeProps) {
  const style = STATUS_BADGE_STYLES[status] || DEFAULT_STYLE;

  return (
    <Badge $bg={style.bg} $color={style.color}>
      {children || status || '-'}
    </Badge>
  );
}
